import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RemoteRecord } from '@client/common/redux/RemoteRecord';
import { AppState } from '@client/common/redux/store';
import {
  fetchContentCollectionEntity,
  selectCollectionEntryByIds,
} from '@client/content/redux/contentCollectionsEntries/redux';
import { ContentCollectionEntryType } from 'b2b-common/core/content/Content.types';

export const CONTENT_COLLECTION_ENTRY = {
  pages: 'jamei_static_pages',
  brandPages: 'jamei_brand_pages',
};

export const useCollectionEntry = (collectionId: string, entryId: string): RemoteRecord<ContentCollectionEntryType> => {
  const dispatch = useDispatch();
  const content = useSelector((state: AppState) => selectCollectionEntryByIds(state, collectionId, entryId));

  useEffect((): void => {
    if (!content.isLoaded) {
      dispatch(fetchContentCollectionEntity({ collectionId, entryId }));
    }
  }, [collectionId, content.isLoaded, entryId]);

  return content;
};
